<template>
  <div>
    <div @click="openModal">
      <img
        src="../../assets/images/icons/qr-code-scan-icon.svg"
        class="ml-1 cursor-pointer"
        width="30px"
        alt="qr_code"
      >
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import QrcodeVue from 'qrcode.vue'

export default {
  components: {},
  props: {
    itemId: {
      type: String,
      default: () => 0,
    },
    itemName: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      size: 200,
      qrVueInstance: null,
    }
  },
  computed: {
    generateQRCodeValue() {
      // Use the route params to dynamically generate the QR code value
      return `https://contact.gulftic.com/${this.itemId}`
    },
  },
  methods: {
    openModal(event) {
      event.stopPropagation()

      const isDark = this.hasClass('dark-layout')

      this.$swal.fire({
        html: '<div id="qr-swal-root"></div>',
        showConfirmButton: false,
        showCloseButton: false,
        width: 450,
        background: isDark ? '#212121ff' : '#f7f7f7ff',
        customClass: {
          popup: 'qr-swal-popup',
        },
        didOpen: () => {
          const container = document.getElementById('qr-swal-root')
          if (!container) return

          this.qrVueInstance = new Vue({
            render: h => h('div', { class: 'qr-code-content' }, [
              h('div', { class: 'container' }, [
                h(QrcodeVue, {
                  props: {
                    value: this.generateQRCodeValue,
                    size: this.size,
                    level: 'H',
                    background: isDark ? '#212121ff' : '#f7f7f7ff',
                    foreground: '#0564f2ff',
                  },
                }),
              ]),
              h('h2', this.itemName),
            ]),
          }).$mount(container)
        },
        willClose: () => {
          if (this.qrVueInstance) {
            this.qrVueInstance.$destroy()
            this.qrVueInstance = null
          }
        },
      })
    },
    hasClass(className) {
      // Check if the element has the specified class
      return document.querySelector(`.${className}`) !== null
    },
  },
}
</script>
<style>
.qr-code-content {
  margin: 8%  0% 0% 0%;
  height: 40vh;
}
.qr-code-content h2 {
  color: #0665f1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 25px;
}
.container {
  position: relative;
  width: 80%;
  height: 80%;
}
.container > div{
  width: 100% !important;
  height: 100% !important;
  display: block;
}
.container > div > canvas{
  width: 100% !important;
  height: 100% !important;
  display: block;
}
.container::before {
  content: "";
  position: absolute;
  top: calc(50% - 51.5px);
  left: calc(50% - 51.5px);
  width: 103px;
  height: 103px;
  border-radius: 50%;
  background-image: url("../../assets/images/logo/QR.png"); /* Set the path to your background image */
  background-size: cover;
  z-index: 0;
}
.dark-layout .container::before {
  content: "";
  position: absolute;
  top: calc(50% - 51.5px);
  left: calc(50% - 51.5px);
  width: 103px;
  height: 103px;
  border-radius: 50%;
  background-image:  url("../../assets/images/logo/QR-logo.png"); /* Set the path to your background image */
  background-size: cover;
  z-index: 0;
}
</style>
